import {createContext} from 'react'

export default createContext({
    email:"",
    name:""
})
